import type { Observable } from 'rxjs';
import { lastValueFrom, take } from 'rxjs';

export function asPromise<T>(stream$: Observable<T>): Promise<T> {
  return lastValueFrom(stream$.pipe(take(1)));
}
